import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { MapVM } from './MapVM';
import esriMap from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import './map.scss';

export interface IMapComponentProps {
  map(map: esriMap);
  view(view: MapView);
  goHome?: () => void;
}

const MapComponent = (props: IMapComponentProps) => {
  const vmRef = useRef<MapVM>();
  if (!vmRef.current) vmRef.current = new MapVM(props);
  const vm = vmRef.current;
  vm.goHome = props.goHome;

  useEffect(() => {
    vm.mapMount(props);
  }, []);

  return <div ref={vm} className="map-component-container"></div>;
};

export const MapComp = observer(MapComponent);
